import http from "./httpService";
import { itemGroupMapApi } from "./config.json";
import auth from "./authService";

export async function getDataForModal(val) {
  const obj = { val };
  const { data } = await http.post(itemGroupMapApi + "selectModalData.php", obj);
  return data;
}
export async function getData(search, limit, offset, order, type) {
  const obj = { search, order, type, limit, offset };
  const { data } = await http.post(itemGroupMapApi + "selectData.php", obj);
  return data;
}
export async function getAllData(search, limit, offset, order, type) {
  const obj = { search, order, type, limit, offset };
  const { data } = await http.post(itemGroupMapApi + "selectAllData.php", obj);
  return data;
}
export async function getDataById(id_item_group_map) {
  const obj = { id_item_group_map };
  const { data } = await http.post(itemGroupMapApi + "selectoneData.php", obj);
  return data;
}
export async function deleteData(id_item_group_map) {
  const obj = { id_item_group_map };
  const { data } = await http.post(itemGroupMapApi + "deleteData.php", obj);
  return data;
}
export async function insertData(header, detail) {
  const username = auth.getCurrentUser();
  const obj = { header, detail, username };
  const { data } = await http.post(itemGroupMapApi + "insertData.php", obj);
  return data;
}
export async function updateData(header,detail, currDetail) {
  const obj = { header,detail, currDetail };
  const { data } = await http.post(itemGroupMapApi + "updateData.php", obj);
  return data;
}

export async function uploadData(detail) {
  const { data } = await http.post(itemGroupMapApi + "updateData.php", detail);
  return data;
}


export async function getDataDrawing(id_item_group_map, search) {
  const obj = { id_item_group_map, search};
  const { data } = await http.post(itemGroupMapApi + "selectDataDrawing.php", obj);
  return data;
}
export async function getDataDrawingCustomer(id_item_group_map, search) {
  const obj = { id_item_group_map, search};
  const { data } = await http.post(itemGroupMapApi + "selectDataDrawingCustomer.php", obj);
  return data;
}

export async function updateDataQC(detail, titik, currTitik) {
  const obj = { detail, titik, currTitik };
  const { data } = await http.post(itemGroupMapApi + "updateDataQC.php", obj);
  return data;
}
export async function getDataQcForModal(val) {
  const obj = { val };
  const { data } = await http.post(
    itemGroupMapApi + "selectModalDataQc.php",
    obj
  );
  return data;
}
export async function getDataQC(search, limit, offset, order, type) {
  const obj = { search, limit, offset, order, type };
  const { data } = await http.post(itemGroupMapApi + "selectDataQC.php", obj);
  return data;
}
export async function getQCGroupById(id_qc_group_item) {
  const obj = { id_qc_group_item };
  const { data } = await http.post(itemGroupMapApi + "selectoneQCGroup.php", obj);
  return data;
}
export async function updateQcGroup(header) {
  const username = auth.getCurrentUser();
  const obj = { username, header };
  const { data } = await http.post(itemGroupMapApi + "updateQcGroup.php", obj);
  return data;
}

export async function deleteQcDimensi(id_qc_group_item) {
  const obj = { id_qc_group_item };
  const { data } = await http.post(itemGroupMapApi + "deleteQcDimensi.php", obj);
  return data;
}
export async function deleteQcGroup(id_qc_group_item) {
  const obj = { id_qc_group_item };
  const { data } = await http.post(itemGroupMapApi + "deleteQcGroup.php", obj);
  return data;
}
export async function getQCGroupReport(detail) {
  const obj = { detail };
  const { data } = await http.post(itemGroupMapApi + "selectQcGroupReport.php", obj);
  return data;
}
export async function getDataReportQc(search, limit, offset, order, type) {
  const obj = { search, limit, offset, order, type };
  const { data } = await http.post(itemGroupMapApi + "selectDataReportQC.php", obj);
  return data;
}


// WEBPACK FOOTER //
// ./src/services/itemGroupMapServices.js